import { LinkingOptions } from "@react-navigation/native";
import * as Linking from "expo-linking";
const config = {
  screens: {
    home: "",
    about: "about",
    docs: "docs",
    privacyPolicy: "privacy-policy",
    termsOfService: "terms-of-service",
  },
};

const linking = {
  prefixes: [Linking.createURL("/")],
  config,
};

export default linking;
